module.exports = __webpack_public_path__ + "fonts/FreightNeoProBook-Regular.a0d65f3e.otf";